const constants = {
  'RETURN_PROCESS_未処理': 1,
  'RETURN_PROCESS_新品': 2,
  'RETURN_PROCESS_相殺待ち': 3,
  'RETURN_PROCESS_相殺済み': 4,
  'RETURN_PROCESS_代替待ち': 5,
  'RETURN_PROCESS_代替済み': 6,
  'RETURN_PROCESS_破棄待ち': 7,
  'RETURN_PROCESS_破棄済み': 8,
  'RETURN_PROCESS_アウトレット': 9
}

const inventoryStatus = {
  'UNTREATED': 1,
  'PROCESSED': 2
}

const QuantityProduct = {
  'OUT_OF_PRODUCT': '在庫がありません'
}

const ReplacementStatus = {
  'UNTREATED': 1,
  'WAITING_FOR_RETURN': 2,
  'PROCESSED': 3
}

const CONDITIONS_INVENTORY = {
  good: {
    value: 0,
    label: '良品'
  },
  bad: {
    value: 1,
    label: '不良品'
  },
  outlet: {
    value: 2,
    label: 'アウトレット'
  }
}

const RevenueAndProfitFilterType = {
  date: 0,
  year: 1
}

const MapReturnStatusAdminEmail = {
  waitConfirm: 10,
  allConfirm: 11,
  waitConfirmText: '承認待ち',
  allConfirmText: '承認済み'
}

const ReasonReturn = {
  reasonTemporary: '1',
  reason: '0'
}

const DivisionType = [
  {
    'value': 'A',
    'label': '出荷'
  },
  {
    'value': 'D',
    'label': '見積受注出荷'
  },
  {
    'value': 'B',
    'label': '移動'
  },
  {
    'value': 'C',
    'label': '貸出'
  },
  {
    'value': 'E',
    'label': '取置'
  }
]

const BankCompany = [
  {
    'value': 'A',
    'label': 'りそな銀行 秋葉原支店 | 普通預金 1967756'
  },
  {
    'value': 'B',
    'label': '三井住友銀行 柏支店 | 普通預金 8356989'
  },
  {
    'value': 'C',
    'label': '楽天銀行 第二営業支店 | 普通預金 7147045'
  }
]

const OrderStatus = {
  'ORTHER_SHIPPING': 0,
  'NOT_SHIPPED': 1,
  'SHIPPED': 2,
  'PARTIAL_SHIPMENT': 3,
  'ALL': 4,
  'MOVED': 5,
  'NOT_RESERVED': 6,
  'RESERVE_COMPLETED': 7,
  'PARTIAL_RESERVE': 8,
  'MOVE': 9,
  'MOVING': 10,
  'BACKORDER_MANAGE': 11,
  'MOVE_RESERVED': 12
}

const WareHouse = {
  'ALL_INVENTORY': 0,
  'ALL_CONSIGNMENT': -1,
  'TOTAL_INVENTORY': -2
}
const Condition = {
  'GOOD': 0,
  'BAD': 1,
  'OUTLET': 2,
  'ALL': 3,
  'CHOICE': 4
}

export { inventoryStatus, QuantityProduct, ReplacementStatus, CONDITIONS_INVENTORY, RevenueAndProfitFilterType, MapReturnStatusAdminEmail, DivisionType, ReasonReturn, BankCompany, OrderStatus, WareHouse, Condition }
export default constants
